module.exports = __webpack_public_path__ + "img/go.d582829b.png";